import StoreHelper from '../../../store/helper'
import PositionManager from '../../PositionManager'

import { DraggablePlaceholder } from '../index'

export const onDragleave = (e) => {
  // Prevent dragleave logic to be called multiple times
  if (!StoreHelper.isDropTargetDefined()) return

  StoreHelper.setDropTarget(null)
  StoreHelper.removeDragElement(StoreHelper.getActiveViewKey(), DraggablePlaceholder)

  PositionManager.recalculateDropTargetPositions()
}
